import BackendFrontend from "utils/Constants/CommonBeFe.constant";

const mongooseId = "_id";

const filtersModuleName = {
  // All Filters Module Name OR Titles
  PROJECT: "Project",
  TITLE: "Title",
  LOCATION: "Location",
  TEAM: "Team",
  STATUS: "Status",
  SEARCH: "Search",
  COUNTRY: "Country",
  NATIONALITY: "Nationality",
  PROFILE_FUNCTION: "Profile Function",
  CREATED: "Date",
  NAME: "Name",
  FUNCTION: "Function",
  MISSING: "Missing",
  CONDITION: "Condition",
  ASSET: "Asset",
  CATEGORY: "Category",
  TYPE: "Type",
  PURCHASE_TYPE: "Price Type",
  QUANTITY_TYPE: "Quantity Type",

  // All Filter Modules Title Object
  SHIFT_DETAILS_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  REPORT_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  TOOLBOX_TALK_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  USER_MANAGEMENT_FILTERS_TITLE_OBJ: { [mongooseId]: "All", title: "All" },
  NOT_ASSIGNED_PROJECT_FILTER_OBJ: {
    [mongooseId]: BackendFrontend.NOT_ASSIGNED_PROJECT,
    title: "Unassigned",
  },
  DPR_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  PROJECT_TRACKER_FILTERS_TITLE_OBJ: { [mongooseId]: "select", title: "Select" },
  QHSE_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  PROJECT_ORDERS_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },
  COMMON_FILTERS_TITLE_OBJ: { [mongooseId]: "all", title: "All" },

  COMMON_DATE_FILTER_OPTIONS: [
    "All",
    "Today",
    "Yesterday",
    "This Week",
    "This Month",
    "Last Month",
    "This Year",
  ],
  COMMON_CUSTOM_DATE_FILTER_OPTIONS: [
    "All",
    "Today",
    "Yesterday",
    "This Week",
    "This Month",
    "Last Month",
    "This Year",
    "Custom Range",
  ],
  SHIFT_DETAILS_STATUS_FILTER_OPTIONS: [
    "All",
    "Open",
    "Submitted",
    "Checked",
    "In Discussion",
    "Closed",
  ],
  PURCHASE_TYPE_FILTER_OPTIONS: [
    { [mongooseId]: "all", title: "All" },
    { [mongooseId]: "buy", title: "Buy" },
    { [mongooseId]: "rental", title: "Rental" },
  ],
  QUANTITY_TYPE_FILTER_OPTIONS: [
    { [mongooseId]: "all", title: "All" },
    { [mongooseId]: "unique", title: "Unique" },
    { [mongooseId]: "multiple", title: "Multiple" },
  ],

  // All Filter Modules Selected Value And Error Messages
  ALL_IN_SMALL_CASE: "all",
  ALL_WITH_FIRST_LETTER_CAPITAL: "All",
  NO_DATA_FOUND: "No data found",
  SELECT_IN_SMALL_CASE: "select",

  // QHSE Filter Constants
  PRODUCT_QUALITY: "Product Quality",
};

export default filtersModuleName;
